/* eslint-disable import/no-anonymous-default-export */
import { useLocation } from "react-router-dom";
import qs from 'query-string';
import { FaChevronDown } from '@react-icons/all-files/fa/FaChevronDown'
import { FaRegBookmark } from '@react-icons/all-files/fa/FaRegBookmark';
import { MdClose } from '@react-icons/all-files/md/MdClose'
import { FaHeart } from '@react-icons/all-files/fa/FaHeart'
import { FaBookmark } from '@react-icons/all-files/fa/FaBookmark';
import Button from "../../../../components/forms/Button";
import { FaExternalLinkAlt } from '@react-icons/all-files/fa/FaExternalLinkAlt'
import { FaChevronUp } from '@react-icons/all-files/fa/FaChevronUp'
import { getFriendlyTime } from "../../../../services/textService";
import { Avatar, Checkbox, Divider, Spin, Tag } from "antd";
import "./index.scss";
import { JOB_ITEM_VARIANT_SAVED_JOBS, JOB_ITEM_VARIANT_SEARCH } from "./constants";
import { FaMagic } from "@react-icons/all-files/fa/FaMagic";
import { SAVED_JOB_STATUS_TITLE } from "../../../../constants/savedJob";
import StatusPicker from "../StatusPicker";
import { hasCredits } from "../../../../services/billingService";
import { useDispatch, useSelector } from "react-redux";
import { setModalState } from "../../../../store/reducers/Modal/actions";
import { BUTTON_VARIANT_LINK, BUTTON_VARIANT_SECONDARY } from "../../../../components/forms/Button/constants";
import { FaEye } from '@react-icons/all-files/fa/FaEye'
export default props => {
    const { job, isSaved, variant, savedJob, onGenerateResume, isGenerateResumeLoading } = props;
    const isLoading = savedJob && ['start', 'in_progress'].includes(savedJob?.status)
    const { userDetails } = useSelector(({ AuthReducer }) => AuthReducer);
    const dispatch = useDispatch()
    return (
        <div key={job?._id || savedJob?._id} className="job-item">

            <div className="job-item-inner">
                {savedJob?.applicationStatus === 'interested' && <div className="next-task">
                    ✨ Pending Application
                </div>}
                <div className="job-title">
                    <div className="left">
                        {/* <Checkbox className="select-checkbox"
                            checked={savedJob ? props.checked : job.checked}
                            onChange={e => props.onJobChange(job._id, 'checked', e.target.checked, savedJob?._id)}
                        /> */}
                        {job.jobTitle}
                    </div>
                    <div className="right">
                        {/* {savedJob ? SAVED_JOB_STATUS_TITLE[savedJob.status] : <Tag>New Opportunity</Tag>} */}
                    </div>

                </div>
                <div className="company">
                    <div className="left">
                        <Avatar size={25} src={job.companyLogoUrl} />
                        <div className="company-name">{job.company}</div>
                    </div>
                    <div className="right">

                    </div>

                </div>
                <div className="tags">
                    {job.tags.slice(0, 4).map(tag => <Tag>{tag}</Tag>)}
                </div>
            </div>
            <div className="job-item-footer">
                <div className="left">
                    {variant === JOB_ITEM_VARIANT_SAVED_JOBS && savedJob?.status === 'pending' && <Button className="apply-btn"
                        loading={job.loading}
                        variant={BUTTON_VARIANT_SECONDARY}
                        onClick={() => {
                            if (hasCredits(userDetails)) {
                                props.onCreateKitClick(savedJob)
                            }
                            else {
                                dispatch(setModalState('isUpgradeModalOpen', true))
                            }

                        }}
                    >
                        <FaEye />
                        Application Kit
                    </Button>}
                    {props.onGenerateResume && <Button className="apply-btn" loading={isGenerateResumeLoading} variant={BUTTON_VARIANT_SECONDARY} onClick={() => onGenerateResume(savedJob)}>
                        {savedJob?.resume ? <>
                            <FaEye />
                            View Resume
                        </> : <>
                            <FaMagic />
                            Generate Resume
                        </>}
                    </Button>}
                    {variant === JOB_ITEM_VARIANT_SEARCH && <Button className="save-btn"
                        onClick={() => props.onJobChange(job._id, 'saved', !isSaved, savedJob?._id)}
                    >
                        <FaHeart />
                        Save Job
                    </Button>}
                    {savedJob && <StatusPicker savedJob={savedJob} />}
                    {(variant === JOB_ITEM_VARIANT_SEARCH || savedJob?.status === 'pending') && props.onRemoveClick && <Button className="skip-btn"
                    variant={BUTTON_VARIANT_LINK} 
                        onClick={() => props.onRemoveClick(savedJob?._id)} loading={job.loading}>
                        {variant === JOB_ITEM_VARIANT_SEARCH ? 'Skip' : 'Remove'}
                    </Button>}

                </div>
                <div className="right">
                    {variant !== JOB_ITEM_VARIANT_SEARCH && job?.params?.initialDataObj?.url && <div className="details-btn" onClick={() => window.open(job.params.initialDataObj.url)}>
                        <FaExternalLinkAlt />
                        <div className="text">{variant === JOB_ITEM_VARIANT_SEARCH ? 'View Job' : 'Apply Job'}</div>
                    </div>}
                    <div className="details-btn" onClick={() => props.onJobChange(job._id, 'showDescription', savedJob ? !savedJob.showDescription : !job?.showDescription, savedJob?._id)}>
                        {job?.showDescription ? <FaChevronUp /> : <FaChevronDown />}
                        <div className="text">{job?.showDescription || savedJob?.showDescription ? 'Hide details' : 'Show details'}</div>
                    </div>
                    <div className="posted-at" color="#333">{`Posted at: ${getFriendlyTime(job?.postedAt || savedJob?.createdAt)}`}</div>
                    {savedJob?.status === 'applied' && <div color="#333">{`Applied at: ${savedJob?.completedAt}`}</div>}
                    {/* <div className="save-btn" onClick={() => props.onJobChange(job._id, 'saved', !isSaved)}>
                        <div>{isSaved ? <FaBookmark /> : <FaRegBookmark />}</div>
                        <div className="text">{isSaved ? 'Saved' : 'Save'}</div>
                    </div> */}
                </div>
            </div>

            {(job?.showDescription || savedJob?.showDescription) ?
                <div className="job-details">
                    <Divider />
                    <div className="item">
                        <div className="title">Company:</div>
                        <div className="value">{job.company}</div>
                    </div>
                    <div className="item">
                        <div className="title">Location:</div>
                        <div className="value">{job.location}</div>
                    </div>

                    <div className="item">
                        {job.tags.map(tag => <Tag>{tag}</Tag>)}
                    </div>
                    <div className="item" style={{ flexDirection: 'column', alignItems: 'flex-start' }} dangerouslySetInnerHTML={{ __html: job?.jobDescriptionHtml || savedJob?.jobDescriptionText }}>

                    </div>
                </div> : null}
        </div>
    )
}